<div class="popup-confirm-outer" [class.fullscreen-outer]="isFullScreen">
  <div class="popup-confirm-wrapper" [style.position]="popupPosition">
    <div class="popup-confirm" [class.fullscreen]="isFullScreen">
      <div class="popup-header">
        <div class="head-text">{{ heading }}</div>
        <div class="header-actions" [class.headers]="isFullScreen">
          <ng-content select="[header-actions]"></ng-content>
          @if (showCloseIcon) {
            <button
              id="tour-close-popup"
              class="close-icon-btn"
              (click)="onCancel(true)"
              title="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
                width="18"
                height="18"
              >
                <path
                  d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                />
              </svg>
            </button>
          }
        </div>
      </div>

      <ng-content></ng-content>
      @if (showFooterButtons) {
        <div class="confirm-buttons">
          @if (cancelText) {
            <a
              href="javascript:void(0)"
              class="confirm-btn"
              (click)="onCancel()"
              >{{ cancelText }}</a
            >
          }
          <a
            href="javascript:void(0)"
            class="confirm-btn confirm"
            [class.disabled]="isConfirmDisabled"
            (click)="isConfirmDisabled ? null : onConfirm()"
            >{{ confirmText }}</a
          >
        </div>
      }
    </div>
  </div>
</div>
